import { useState, type FormEvent } from "react";

const navItems = [
  { label: "精选推荐", href: "#entries" },
  { label: "分类专区", href: "#categories" },
  { label: "合集大全", href: "#collections" },
  { label: "热度榜单", href: "#rank" },
  { label: "使用指南", href: "#guide" },
  { label: "常见问题", href: "#faq" },
];

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");

  const handleSearch = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const target = document.getElementById("categories");
    if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/70 bg-background-50/90 backdrop-blur">
      <div className="mx-auto flex h-16 w-full max-w-[1280px] items-center justify-between gap-4 px-4 md:px-6">
        <a href="#top" className="flex shrink-0 cursor-pointer items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-door-open-line text-lg" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-base font-bold tracking-tight text-foreground-950">黑料入口</span>
            <span className="mt-0.5 text-[10px] tracking-widest text-foreground-500">导航站整理</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="cursor-pointer whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-foreground-950"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <form
            onSubmit={handleSearch}
            className="hidden items-center gap-1.5 rounded-md border border-background-300/70 bg-background-50 px-2.5 py-1.5 md:flex"
          >
            <i className="ri-search-line text-sm text-foreground-500" />
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜入口 / 题材"
              className="w-28 bg-transparent text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none xl:w-40"
            />
          </form>
          <a
            href="#entries"
            className="hidden cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:block"
          >
            挑入口
          </a>
          <button
            type="button"
            aria-label="展开导航"
            onClick={() => setMenuOpen((v) => !v)}
            className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300/70 text-foreground-800 lg:hidden"
          >
            <i className={menuOpen ? "ri-close-line text-lg" : "ri-menu-line text-lg"} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200/70 bg-background-50 lg:hidden">
          <nav className="mx-auto flex w-full max-w-[1280px] flex-col px-4 py-3 md:px-6">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="cursor-pointer rounded-md px-3 py-2.5 text-sm text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-foreground-950"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#entries"
              onClick={() => setMenuOpen(false)}
              className="mt-2 cursor-pointer rounded-md bg-primary-500 px-4 py-2.5 text-center text-sm font-medium text-background-50"
            >
              挑入口
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}